export default {
    documents: {
        date: 'Дата',
        download: 'Скачать',
        no_data: 'Нет документов',
        review: 'Просмотреть',

        documentRequestWelcome: 'Добро пожаловать, %(pplname)s!',
        documentRequest: 'Требуется загрузить следующий список документов:',
        requestEmpty: 'Нет документов для загрузки',
        types: {
            kadryppldoc: 'Кадровый документ',
            passport: 'Скан пасспорта',
            inn: 'Скан ИНН',
            snils: 'Скан СНИЛС',
            diploma: 'Скан диплома',
            family_cert: 'Скан семейного положения',
            militaryid: 'Скан военного билета',
            privil_cert: 'Скан сертификата о льготе',
            emplhistory: 'Скан трудовой книжки',
            bank_rekv: 'Скан банковских реквизитов',
            opd: 'Согласие ОПД',
        },
        documentRequestSend: 'Закончить внесение документов',
        welcomeSuccess: 'Документы успешно отправлены',

        opdButton: 'Заполнить согласие ОПД',
        cancelOpd: 'Отменить согласие',
        changeOpd: 'Изменить информацию',
        opdModalTitle: 'Согласие на обработку персональных данных',
        openVcv: 'Перейти к просмотру интервью',
    },
};
